import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
// import { i18n } from "./i18n";
import * as VueGoogleMaps from 'gmap-vue';
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyB-lM6ltADhmrqkzoyZfI3UBarxhPhjLKM",
    },
})
// Vue.component('google-kml-layer', VueGoogleMaps.KmlLayer);

Vue.use(GmapCustomMarker)
// para quitar error que no leia dispatch añado esta linea para hacer la variante global
Vue.prototype.$store = store

new Vue({
    router,
    vuetify,
    store,
    // i18n,
    render: h => h(App)}).$mount('#app')
